import type { CashbackType } from '@/backend/market'
import type { CashbackTranslationEntity } from './CashbackTranslationEntity'

export class CashbackOfferEntity {
  createdAt?: string
  updatedAt?: string
  id?: number
  startDate?: string
  endDate?: string
  isActive?: boolean
  type?: CashbackType
  serviceValue?: number
  branchValue?: number
  readonly baseValue?: number
  minCartAmount?: number | null
  maxCashbackAmount?: number | null
  branchCap?: number | null
  atNumberOfOrders?: Array<number> | null
  maxUsage?: number | null
  maxUserUsage?: number | null
  priority?: number | null
  name?: string | null
  translations?: Array<CashbackTranslationEntity> | null
}
